import { render, staticRenderFns } from "./r-item-kind-dropdown-dialog.vue?vue&type=template&id=393c266e&scoped=true"
import script from "./r-item-kind-dropdown-dialog.vue?vue&type=script&lang=js"
export * from "./r-item-kind-dropdown-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-item-kind-dropdown-dialog.vue?vue&type=style&index=0&id=393c266e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393c266e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('393c266e')) {
      api.createRecord('393c266e', component.options)
    } else {
      api.reload('393c266e', component.options)
    }
    module.hot.accept("./r-item-kind-dropdown-dialog.vue?vue&type=template&id=393c266e&scoped=true", function () {
      api.rerender('393c266e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/r-item-kind-dropdown-dialog.vue"
export default component.exports